import PropTypes from "prop-types";
import PremierPricingTableRow from "./PremierPricingTableRow/index.jsx";
import style from "./styles";
import { createMarkup } from "../../helpers";
import tableData from "../../data/tableData";

const getFooterText = (
  selectedCountry,
  premierDeliveryPrices,
  deliveryData
) => {
  const countriesWithMinimumThreshold = ["GB", "HK", "SG", "SA", "AE", "ES"];
  const baseFooterText = countriesWithMinimumThreshold.includes(selectedCountry)
    ? premierDeliveryPrices.footerTextWithMinimumThreshold
    : premierDeliveryPrices.footerText;
  return baseFooterText
    .replace("%deliveryType%", deliveryData.deliveryOptionType.name)
    .replace("%price%", deliveryData.price.text);
};

const orders = [1, 2, 5, 10, 15, 20];

const PremierPricingTable = ({
  deliveryData,
  countryData,
  premierDeliveryPrices,
  selectedCountry,
}) => {
  const language = window.asos.webContext.getBrowseLanguage();
  return deliveryData ? (
    <div className={style.PremierPricingTableContainer}>
      <h2>{premierDeliveryPrices.title}</h2>
      <p
        dangerouslySetInnerHTML={createMarkup(
          deliveryData,
          countryData,
          premierDeliveryPrices
        )}
      ></p>
      <table className={style.PremierPricingTable}>
        <caption>{tableData[language].totalCost}</caption>
        <thead className={style.PremierPricingTableHead}>
          <tr>
            <th className={style.orders} scope="col">
              <span>{tableData[language].ordersPerYear}</span>
            </th>
            <th className={style.gray} scope="col">
              <span>{tableData[language].withoutPremier}</span>
            </th>
            <th className={style.blue} scope="col">
              <span>{tableData[language].withPremier}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {orders.map((orderNum, i) => (
            <PremierPricingTableRow
              key={i}
              orderNum={orderNum}
              countryData={countryData}
              deliveryData={deliveryData}
              premierDeliveryPrices={premierDeliveryPrices}
              style={style}
            />
          ))}
        </tbody>
      </table>
      <p className={style.PremierPricingFooter}>
        {getFooterText(selectedCountry, premierDeliveryPrices, deliveryData)}
      </p>
    </div>
  ) : null;
};

PremierPricingTable.propTypes = {
  deliveryData: PropTypes.shape({
    deliveryOptionType: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
    price: PropTypes.shape({
      text: PropTypes.string.isRequired,
    }),
  }),
  countryData: PropTypes.object.isRequired,
  premierDeliveryPrices: PropTypes.shape({
    footerText: PropTypes.string.isRequired,
    footerTextWithMinimumThreshold: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
  selectedCountry: PropTypes.string.isRequired,
};

export default PremierPricingTable;
